/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pro_User_Appreciation_Letter_Gratitude_Body2Inputs */

const en_pro_user_appreciation_letter_gratitude_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Because of you, Forest was able to flourish.`)
};

const ar_pro_user_appreciation_letter_gratitude_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بفضلك، تمكنت الغابة من الازدهار.`)
};

const de_pro_user_appreciation_letter_gratitude_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dank Ihnen konnte Forest aufblühen.`)
};

const es_pro_user_appreciation_letter_gratitude_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gracias a ti, Forest ha podido prosperar.`)
};

const fr_pro_user_appreciation_letter_gratitude_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est grâce à vous que Forest a pu s'épanouir.`)
};

const it_pro_user_appreciation_letter_gratitude_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grazie a te, Forest ha potuto prosperare.`)
};

const ja_pro_user_appreciation_letter_gratitude_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたのおかげで、Forestはここまで成長することができました。`)
};

const ko_pro_user_appreciation_letter_gratitude_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest가 번창할 수 있었던 것도 다 사용자님 덕분이에요.`)
};

const pt_br_pro_user_appreciation_letter_gratitude_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por sua causa, o Forest pode desabrochar.`)
};

const ru_pro_user_appreciation_letter_gratitude_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest смог расцвести благодаря вам.`)
};

const th_pro_user_appreciation_letter_gratitude_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เป็นเพราะคุณ Forest จึงสามารถเติบโตได้อย่างงดงาม`)
};

const tr_pro_user_appreciation_letter_gratitude_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sizin sayenizde Forest gelişebildi.`)
};

const zh_cn_pro_user_appreciation_letter_gratitude_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`因为有你，
Forest 才能够成长茁壮`)
};

const zh_tw_pro_user_appreciation_letter_gratitude_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`因為有你，
Forest 才能夠成長茁壯`)
};

/**
* | output |
* | --- |
* | "Because of you, Forest was able to flourish." |
*
* @param {Pro_User_Appreciation_Letter_Gratitude_Body2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const pro_user_appreciation_letter_gratitude_body2 = /** @type {((inputs?: Pro_User_Appreciation_Letter_Gratitude_Body2Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pro_User_Appreciation_Letter_Gratitude_Body2Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pro_user_appreciation_letter_gratitude_body2(inputs)
	if (locale === "ar") return ar_pro_user_appreciation_letter_gratitude_body2(inputs)
	if (locale === "de") return de_pro_user_appreciation_letter_gratitude_body2(inputs)
	if (locale === "es") return es_pro_user_appreciation_letter_gratitude_body2(inputs)
	if (locale === "fr") return fr_pro_user_appreciation_letter_gratitude_body2(inputs)
	if (locale === "it") return it_pro_user_appreciation_letter_gratitude_body2(inputs)
	if (locale === "ja") return ja_pro_user_appreciation_letter_gratitude_body2(inputs)
	if (locale === "ko") return ko_pro_user_appreciation_letter_gratitude_body2(inputs)
	if (locale === "pt_br") return pt_br_pro_user_appreciation_letter_gratitude_body2(inputs)
	if (locale === "ru") return ru_pro_user_appreciation_letter_gratitude_body2(inputs)
	if (locale === "th") return th_pro_user_appreciation_letter_gratitude_body2(inputs)
	if (locale === "tr") return tr_pro_user_appreciation_letter_gratitude_body2(inputs)
	if (locale === "zh_cn") return zh_cn_pro_user_appreciation_letter_gratitude_body2(inputs)
	return zh_tw_pro_user_appreciation_letter_gratitude_body2(inputs)
});